/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { jsmIncidentsEntryPoint } from '@jira/work-item__jsm-incidents/src/jsmIncidentsEntryPoint.entrypoint.tsx';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { JsmWorkItemIncidentEntrypointProps } from './JsmWorkItemIncident.entrypoint.types.tsx';

type PreloadedEntryPoints = {
	incidentView: typeof jsmIncidentsEntryPoint;
};

type JsmWorkItemIncidentEntryPointComponent = EntryPointComponent<
	Record<string, never>,
	PreloadedEntryPoints,
	JsmWorkItemIncidentEntrypointProps,
	Record<string, never>
>;

export const jsmWorkItemIncidentEntryPoint: EntryPoint<
	JsmWorkItemIncidentEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<JsmWorkItemIncidentEntryPointComponent>(
		/* webpackChunkName: "async-jsm-work-item-incident" */ './JsmWorkItemIncident.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: (params: EntryPointRouteParams) => ({
		entryPoints: {
			incidentView: {
				entryPoint: jsmIncidentsEntryPoint,
				entryPointParams: {
					activeTabKey: params.context.query.tab,
				},
			},
		},
	}),
});
